import runAccessibility from "@/views/menu/runAccessibility";
import { renderWidget } from "@/views/widget/widget"

import { 
    userSettings,
    getSavedUserSettings,
    saveUserSettings
} from '@/globals/userSettings';

import {
    pluginConfig
} from "./globals/pluginConfig";
import { changeLanguage } from "./i18n/changeLanguage";

let accessibilityObserver: MutationObserver | null = null;
let reapplyTimeout: NodeJS.Timeout | null = null;

export default function sienna({
    options
}) {
    const savedSettings = getSavedUserSettings();

    Object.assign(pluginConfig, options);
    Object.assign(userSettings, savedSettings);

    if (userSettings.states?.['new-button']) {
        userSettings.states['new-button'] = false;
        saveUserSettings();
    }

    // Always initialize language from the page locale (pluginConfig.lang),
    // so the widget renders in the correct language on first load.
    // observeHTMLLang will keep it in sync on subsequent SPA navigations.
    userSettings.lang = pluginConfig.lang;

    runAccessibility();
    renderWidget();

    // Setup observer to re-apply accessibility settings on DOM changes
    if (!accessibilityObserver) {
        accessibilityObserver = new MutationObserver((mutations) => {
            // Check if new nodes were added to the DOM (excluding widget elements)
            const hasNewNodes = mutations.some(mutation => 
                mutation.addedNodes.length > 0 && 
                Array.from(mutation.addedNodes).some(node => 
                    node.nodeType === Node.ELEMENT_NODE && 
                    !(node as Element).closest('.asw-container, .asw-menu')
                )
            );

            if (hasNewNodes && (userSettings?.states?.fontSize || userSettings?.states?.contrast || Object.keys(userSettings?.states || {}).length > 0)) {
                // Debounce to avoid excessive re-runs
                if (reapplyTimeout) {
                    clearTimeout(reapplyTimeout);
                }
                
                reapplyTimeout = setTimeout(() => {
                    runAccessibility();
                    reapplyTimeout = null;
                }, 100);
            }
        });

        accessibilityObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    return {
        changeLanguage
    }
}
